import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Input, Select } from '@leasequery/lq.react-component-library'
import contractOptions from './contractOptions'
import postSubmit from '../../submit-hubspot/apiPost'

export default function SubmitForm({ submitForm }) {
	const history = useHistory()
	const [errorMessage, setErrorMessage] = useState('')
	const [inputForm, setInputForm] = useState({
		firstName: '',
		lastName: '',
		email: '',
		phone: '',
		estimatedSbitaContracts: '',
		emailArray: [''],
	})

	let context = {}
	let identifier = ''

	context = {
		pageUri: 'https://tools.leasequery.com/gasb-96-sbita-identifier',
		pageName: 'GASB 96 SBITA Identifier',
	}
	identifier = 'sbita'

	const userResponses = {
		submittedAt: '',
		fields: [
			{
				name: 'firstname',
				value: inputForm.firstName,
			},
			{
				name: 'lastname',
				value: inputForm.lastName,
			},
			{
				name: 'estimated___of_sbita_contracts',
				value: inputForm.estimatedSbitaContracts.value,
			},
			{
				name: 'phone',
				value: inputForm.phone,
			},
			{
				name: 'email',
				value: inputForm.email,
			},
			{
				name: 'additional_emails',
				value: inputForm.emailArray.toString(),
			},
		],
		context,
	}

	function validateForm() {
		const email = validateEmail(inputForm.email)
		const phone = validatePhone(inputForm.phone)
		const errors = Object.keys(inputForm).filter(
			(key) => key !== 'emailArray' && key !== 'phone' && inputForm[key] === ''
		)
		let emailArray = true
		let filteredArray

		if (inputForm.emailArray.length > 0) {
			filteredArray = inputForm.emailArray.filter((email) => email !== '')
			const validateArray = filteredArray.map((email) => validateEmail(email))
			if (validateArray.includes(false)) {
				emailArray = false
			}
		}

		if (email && phone && emailArray && errors.length === 0) {
			setErrorMessage('')

			sessionStorage.clear()

			postSubmit(userResponses, identifier).then((hubSpotResponse) => {
				if (
					hubSpotResponse.errors &&
					hubSpotResponse.errors[0].errorType === 'BLOCKED_EMAIL'
				) {
					setErrorMessage('Submissions from this email address are not allowed')
				} else {
					submitForm(
						hubSpotResponse.redirectUri,
						inputForm.email,
						inputForm.firstName
					)
				}
			})
		} else if (!phone) {
			setErrorMessage(`Please enter a valid phone number`)
		} else {
			setErrorMessage(`Please fill out all fields in order to submit`)
		}
	}

	function onChange(name, value) {
		setInputForm({ ...inputForm, [name]: value })
	}

	function navigateBack() {
		sessionStorage.setItem('formActive', '1')
		history.goBack()
	}

	function validateEmail(email) {
		// eslint-disable-next-line
		const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		return re.test(email)
	}

	function validatePhone(phone) {
		// (123) 456-7890, (123)456-7890, 123,456,7890, 123.456.7890, 1234567890, +3163633634, 075-63646725
		// eslint-disable-next-line
		const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
		if (phone === '' || phone.match(re)) {
			return true
		} else {
			return false
		}
	}

	return (
		<div className='form-Container'>
			<Input
				name='firstName'
				value={inputForm.firstName}
				onChange={(e) => onChange('firstName', e.target.value)}
				disabled={false}
				label='First Name'
				type='text'
				className='form-Input'
				required={true}
			/>

			<Input
				name='lastName'
				value={inputForm.lastName}
				onChange={(e) => onChange('lastName', e.target.value)}
				disabled={false}
				label='Last Name'
				type='text'
				className='form-Input'
				required={true}
			/>

			<Input
				name='email'
				value={inputForm.email}
				onChange={(e) => onChange('email', e.target.value)}
				disabled={false}
				label='Work Email'
				type='text'
				className='form-Input'
				required={true}
			/>

			<Input
				name='phone'
				value={inputForm.phone}
				onChange={(e) => onChange('phone', e.target.value)}
				disabled={false}
				label='Phone Number'
				type='text'
				className='form-Input'
			/>

			<Select
				name='estimatedSbitaContracts'
				options={contractOptions}
				value={inputForm.estimatedSbitaContracts}
				onChange={(e) => onChange('estimatedSbitaContracts', e)}
				disabled={false}
				label='Estimated # of SBITA Contracts'
				className='form-Input'
				required={true}
			/>

			<div className='text-Privacy'>
				Your information will be treated in accordance with our{' '}
				<a href='https://leasequery.com/privacy-statement/'>
					privacy statement.
				</a>
			</div>

			<div className='errorMessage-Container'>{errorMessage}</div>

			<div className='form-Button-Container'>
				<Button
					buttonType='secondary'
					className='form-Button'
					onClick={() => navigateBack()}
				>
					Back
				</Button>

				<Button
					buttonType='primary'
					className='form-Submit-Button'
					onClick={() => validateForm()}
				>
					Send Results
				</Button>
			</div>
		</div>
	)
}
